import { twMerge } from 'tailwind-merge';
import DefaultBannerImage from '@ui/assets/images/DefaultBanner.png';
import { LoadingSkeleton } from './loading-skeleton';
import { IBannerType, Spinner } from '@ui/components';

const BannerTypeSizeMap = {
  fan: 'h-40 lg:h-52 xl:h-60 rounded-t-xl',
  creator: 'h-20 rounded-t-md',
  preview: 'rounded-t-xl max-h-[160px]',
  content: 'h-40 rounded-t-md',
};

interface IBanner {
  image?: string;
  type: IBannerType;
  className?: string;
  isLoading?: boolean;
  showSpinner?: boolean;
  onImageLoad?: () => void;
}

export function BannerV1({
  image,
  type,
  isLoading,
  className,
  showSpinner = false,
  onImageLoad,
}: IBanner) {
  const bgImage = image || DefaultBannerImage.src;
  const typeStyles = BannerTypeSizeMap[type];

  return isLoading ? (
    <LoadingSkeleton
      className={twMerge('h-auto max-h-[200px] min-h-[100px] w-full', typeStyles, className)}
    />
  ) : (
    <div>
      {showSpinner && (
        <Spinner className="absolute z-10 animate-spin top-44 left-32" fill={'#FF600D'} />
      )}
      <img
        className={twMerge(
          'h-auto max-h-[200px] min-h-[100px] w-full object-cover',
          typeStyles,
          className,
        )}
        src={bgImage}
        onLoad={onImageLoad}
      />
    </div>
  );
}
